import React from "react";
import { useNavigate } from "react-router-dom";
import { TasteProfileOnboardingFlow } from "../v32/components/onboarding/TasteProfileOnboardingFlow";
import { trackEvent } from "../v32/config/analytics";
import { useUser } from "../hooks/useUser";

/**
 * Dedicated Onboarding Page - Full page onboarding experience
 *
 * This replaces the modal-based onboarding with a dedicated route.
 * Users are redirected here after login if they need onboarding.
 */
export const OnboardingPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const handleOnboardingComplete = () => {
    // Track completion
    trackEvent("user_onboarding_completed" as any, {
      userId: user?.id,
      userEmail: user?.email,
      completionTimestamp: Date.now(),
    });

    console.log("[Onboarding] Completed - redirecting to dashboard");

    // Navigate to dashboard after completion
    navigate("/dashboard", { replace: true });
    // Ensure scroll resets to top after route change
    try {
      if (typeof window !== 'undefined') {
        // Defer to allow route switch to occur first
        setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }), 0);
      }
    } catch {}
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sage-50 to-coral-50">
      <div className="container mx-auto px-4 py-8">
        <div className="mx-auto max-w-2xl">
          <div className="mb-8 text-center">
            <h1 className="mb-2 text-3xl font-bold text-dusk">
              Welcome to Nura! 🌟
            </h1>
            <p className="text-supporting text-lg">
              Let's personalize your meal planning experience
            </p>
          </div>

          <div className="rounded-xl bg-card text-card-foreground p-8 shadow-lg">
            <TasteProfileOnboardingFlow onComplete={handleOnboardingComplete} />
          </div>
        </div>
      </div>
    </div>
  );
};
